<template>

<div class="w-100">

    <div v-if='!isReady'>
        <loader></loader>
    </div>

    <div v-if='isReady' class="sub-comments">
    
        <span @click='openComments()' v-if='!config.alwaysOpen' class="comment-link d-flex justify-content-center justify-content-md-start align-items-center text-muted">
            <span class="icon icon-dialog mr-1"></span>
            <span class="text">Comments<span class="sm-text"> to this review</span></span>
            <span class="counter">{{ count }}</span>
        </span>

         <transition name="slide">
            <div v-if='show' class='row'>
                <div class="col-12">
                    <div v-for='(c,i) in comments' :class='["comment", { deleted : c.is_deleted == 1 }]'>
                        <div class="comment-box mt-4">
                            <div class="d-flex flex-column flex-md-row align-items-center align-items-md-start">                   
                                <div class="user-avatar mr-md-3 text-center">
                                    <img :src='c.avatar ? c.avatar : "/resources/user.jpg"' class="img-fluid"> 
                                </div>
                                <div class="w-100">
                                    <div class="d-flex align-items-center justify-content-between flex-column flex-md-row mb-2">
                                        <strong class="d-block mt-2 text-muted">{{ c.author }}</strong>
                                        <small class="text-muted d-flex flex-column flex-md-row mt-2 justify-content-center">
                                            <!-- <span @click='edit(c)' class='pointer edit d-flex justify-content-center align-items-center mr-md-3'
                                                v-if='canEdit == c.uid && c.is_deleted != 1 && edited != c.id && !config.adminMode'>
                                                <span class="icon icon-gear mr-1"></span>
                                                Edit the comment
                                            </span>
                                            <span v-if='edited == c.id' class="d-flex justify-content-center align-items-center mr-md-3">
                                                <span class="icon icon-waiting mr-1"></span>
                                                Edititng... 
                                            </span> -->
                                            <div class="d-flex align-items-center">
                                                <span class="icon icon-calendar1 mr-1"></span>
                                                {{ c.created_at }}
                                            </div>
                                        </small>
                                    </div>

                                    <div class="row">
                                        <div class='col-12'>
                                            <div v-if='edited !== c.id' class="review-content text-center text-md-left">{{ c.comment }}</div>

                                            <!-- <div v-if='edited == c.id' class="mb-0 mt-3">
                                                <div class="input-group">
                                                    <label class="label" for="edit-comment">
                                                        Edit your comment:
                                                    </label>
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <span class="icon icon-writing"></span>
                                                        </div>
                                                    </div>
                                                    
                                                        <input @change='updateComment(c)' 
                                                                class='form-control' v-model.trim='c.comment' id="edit-comment">
                                                </div>
                                                <span class="text-xs-small d-block mb-2 ml-1">
                                                    When you're ready hit "Enter" to save the changes.
                                                </span>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button @click='deleteComment(c,i)' 
                                            class='btn btn-danger mr-2 mt-2 mb-2' v-if='config.adminMode'>
                                        Delete
                                    </button>
                                    <button @click='softDeleteComment(c,i)' 
                                            :class='["btn btn-warning mt-2 mb-2", c.is_deleted ? "btn-success": "btn-warning"]' 
                                            v-if='config.adminMode'>
                                        <span v-if='c.is_deleted == 0'>Soft Delete</span>
                                        <span v-if='c.is_deleted == 1'>Restore</span>
                                    </button>
                                </div>
                            </div>

                            <div v-for='(r,ii) in c.replies' 
                                 :class='["comment-box mt-4", { deleted : r.is_deleted == 1 }]'>
                                <div class="d-flex flex-column flex-md-row align-items-center align-items-md-start">
                                    <div class="user-avatar mr-md-3 text-center">
                                        <img :src='r.avatar ? r.avatar : "/resources/user.jpg"' class="img-fluid">
                                    </div>

                                    <div class="w-100">
                                        <div class="d-flex align-items-center justify-content-between flex-column flex-md-row mb-2">
                                            <strong class="d-block mt-2 text-muted">{{ r.author }}</strong>
                                            <small class="text-muted d-flex flex-column flex-md-row mt-2 justify-content-center">
                                                <!-- <span class="pointer edit d-flex justify-content-center align-items-center mr-md-3" 
                                                    @click='edit(r)' v-if='canEdit == r.uid && r.is_deleted != 1 && edited != r.id && !config.adminMode'>
                                                    <span class="material-icons-round">&#xf097;</span>
                                                    Edit the comment
                                                </span> -->

                                                <span class="d-flex align-items-center">
                                                    <span class="icon icon-calendar1"></span>
                                                    {{ r.created_at }}
                                                </span>
                                            </small>
                                        </div>

                                        <div class="row">
                                            <div class="col-12">
                                                <div v-if='edited !== r.id' class="review-content text-center text-md-left">{{ r.comment }}</div>

                                                <div class="alert alert-secondary mb-0" v-if='edited == r.id'>
                                                    <label class="label pl-0 mb-0 d-flex align-items-center" for="edit-comment">
                                                        <span class="material-icons-round">
                                                            &#xe8d2;
                                                        </span>
                                                        Edit your comment:
                                                    </label>
                                                
                                                    <span class="text-xs-small d-block mb-2 ml-1">
                                                        When you're ready hit "Enter" to save the changes.
                                                    </span>
                                            
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">
                                                                <span class="material-icons-round">&#xf097;</span>
                                                            </div>
                                                        </div>

                                                        <input @change='updateComment(r)' class='form-control' v-model.trim='r.comment'> 
                                                    </div>
                                                </div>                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            
                                <div class="col-12">
                                    <button @click='deleteComment(r,ii)' 
                                            class='btn btn-danger float-right' v-if='config.adminMode'>
                                        Delete
                                    </button>                       
                                    <button @click='softDeleteComment(r,ii)' 
                                            :class='["btn float-right", r.is_deleted ? "btn-success": "btn-warning"]' 
                                            v-if='config.adminMode'>
                                        <span v-if='r.is_deleted == 0'>Soft Delete</span>
                                        <span v-if='r.is_deleted == 1'>Restore</span>
                                    </button>
                                </div>
                            </div>

                            
                            <div v-if='config.canComment && user' class="input-group mt-4">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <span class="icon icon-writing"></span>
                                    </div>
                                </div>
                                <input @keyup.enter='leaveReply(c)' v-if='config.canComment && user' v-model='reply[c.id]' 
                                       class='form-control' placeholder="Type your comment here and hit “enter” to send it.">
                            </div>
                        </div>
                    </div>

                    <!-- New Comment -->
                    <div>
                        <div v-if='isReady && init && !comments.length' class="alert alert-info mt-3" role="alert">
                            <div class="alert-icon">
                                <span class="icon icon-dialog"></span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center w-100">
                                <div>
                                    <span class="text-bold d-block">Sorry!</span>
                                    <span class="text-small">There are no comments yet. You can write the first one!</span>
                                </div>
                            </div>
                        </div>

                        <div v-if='config.canComment && user' class="new-comment mt-4">
                            <div class="d-flex align-items-md-center flex-column flex-md-row">
                                <p class="mb-0">Leave a reply:</p>

                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="icon icon-writing"></span>
                                        </div>
                                    </div>
                                
                                    <input @keyup.enter='leaveComment(c)' class='form-control' 
                                       v-model='comment' placeholder="Type your comment here and hit “enter” to send it.">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( typeof this.conf != 'object' ) {
                console.log("No config provided for comments module.");
            
            } else {

                this.config = Object.assign({}, this.conf);
                this.initReplyModel();
                this.isReady = true;
            }

            if( typeof this.c == 'number' ) {
                this.count = this.c;
            }

            if( this.config.alwaysOpen ) {
                this.show = true;
            }

            if( this.config.preload || this.config.alwaysOpen ) {
               this.getData();
            } 

            if( this.user ) {
                this.canEdit = this.user.id;
            }

        },

        props : ['conf','id','c'],

        data() {
            return {
                isReady  : false,
                init     : 0,
                show     : false,
                count    : 0,

                edited : false,
                canEdit : false,

                config : {
                    updc    : false,
                    preload : false,
                    alwaysOpen : false,
                    canComment : true,
                    adminMode  : false,
                    url : {
                        get : '/get/comments/here',
                        add : '/add/new/comment',
                        upd : '/update/comment/',
                        del : '/delete/comment/',
                        sdel : '/soft-delete/comment/',
                    }
                },

                comments : [], 

                reply : {

                },

                comment  : '',
            }
        },

        methods : {

            openComments() {
                if( !this.init ) {
                    this.getData();
                } else {
                    this.show = !this.show;
                }
            },

            edit( c ) {
                if( c.uid == this.user.id && c.is_deleted != 1 ) {
                    this.edited = c.id;
                }
            },

            getData(c) {

                this.ajax.call( this.config.url.get, { id : this.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        this.init = 1;
                        this.comments = r.data;

                        this.initReplyModel();

                        if( !this.count ) {
                            this.count = this.comments.length;
                        }

                        this.show = true;
                    }

                })

            },

            addComment(c) {

                this.ajax.call( this.config.url.add, c, (r) => {
                    
                    if( r.status == 'success' ) {

                        r.data.avatar = this.user.avatar;
                        r.data.uid = this.user.id;

                        if( !c.comment_id ) {
                            
                            r.data.replies = [];
                            this.comments.push( r.data );

                        } else {

                            for( var i in this.comments ) {
                                if( this.comments[i].id == c.comment_id ) {
                                    this.comments[i].replies.push( r.data );
                                    break;
                                }
                            }
                        }

                        this.count += 1;

                        if( this.config.updc ) {
                            bus.$emit('updc-' + this.config.updc, 1 );
                        }

                    } else {
                        $.notify( r.message, 'warning' );
                    }

                })

            },

            deleteComment(c,i) {

                if( !confirm('Are you sure?') ) {
                    return;
                }

                this.ajax.call( this.config.url.del, c, (r) => {
                    
                    if( r.status == 'success' ) {

                        if( !c.comment_id ) {

                            this.comments.splice(i,1);

                        } else {

                            for( var j in this.comments ) {
                                if( this.comments[j].id = c.comment_id ) {
                                    this.comments[j].replies.splice(i,1);
                                    break;
                                }
                            }

                        }

                        this.count -= 1;

                    }

                })

            },

            softDeleteComment(c,i) {
                var com = { id : c.id };

                if( c.is_deleted == 0 ) {
                    
                    if( !confirm('Soft delete comment?') ) {
                        return;
                    }

                    com.s = 1;
                    
                } else {

                    if( !confirm('Restore comment?') ) {
                        return;
                    }
                    
                    com.s = 0;

                }

                this.ajax.call( this.config.url.sdel, com, (r) => {
                    
                    if( r.status == 'success' ) {

                        c.is_deleted = com.s;
                        c.comment = r.data.c;
                    }

                })

            },

            updateComment(c) {
                var data = { 
                    id : c.id,
                    comment : c.comment
                };

                this.ajax.call( this.config.url.upd, data , (r) => {
                    if( r.status == 'success' ) {
                        this.edited = false;
                    }
                })

            },

            leaveReply(c) {
                if( !this.reply[c.id].length ) {
                    return;
                }

                var cmt = {
                    comment_id : c.id,
                    item_id  : this.id,
                    comment    : this.reply[c.id]
                }

                this.addComment( cmt );

                this.reply[c.id] = '';

                this.reply = Object.assign({}, this.reply);
            },

            leaveComment(c) {
                if( !this.comment.length ) {
                    return;
                }

                var cmt = {
                    comment_id : null,
                    item_id  : this.id,
                    comment    : this.comment
                }

                this.addComment( cmt );

                this.comment = '';
            },

            editComment(c) {
                alert("Edit Comment");
            },

            initReplyModel() {
                for( var i in this.comments ) {

                    if( typeof this.comments[i].id == 'number' ) {
                        this.reply[ this.comments[i].id ] = '';
                    }
                }

            }

        }

    }
</script>
<style>

/*.comment-box {
    background: #e8e8e8;
    padding: 10px;
    margin: 10px;
}

.comment-box .comment {
    background: white;
    padding: 5px;
    margin : 5px 0;
    border: 1px solid #b7b7b7;
    border: 1;
}

.comment-box .comment .comment-reply {
    padding-left: 40px;
    margin: 10px 0;
}

.comment-box .comment .comment-reply.deleted {
    border : 1px solid red;
}

.comment-box .comment.deleted {
    border : 1px solid red;
}*/

</style>